import dynamic from 'next/dynamic';

import { CTABannerProps } from '@/components/molecules';
import { createImage } from '@/lib/utils/createImageObject';
import { resolvePageSlug } from '@/lib/utils/dynamicPageSlug';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import { WidgetPlugin } from './types';

import { Page, SiteConfigResponse, Widget } from '@/lib/api/types';

export const CTABannerBasicPlugin: WidgetPlugin<CTABannerProps> = {
  type: TYPES.IMAGE_BANNER,
  template: TEMPLATES.BASIC,
  component: dynamic(() =>
    import('@/components/molecules').then(mod => mod.CTABanner),
  ),
  mapProps: (
    widget: Widget,
    siteData?: {
      site: SiteConfigResponse;
      pages: Page[];
    },
  ) => {
    const href = resolvePageSlug(
      siteData?.pages || [],
      widget.content_parameters,
    );

    return {
      title: widget.title,
      href,
      description: Array.isArray(widget.template.parameters)
        ? ''
        : (widget.template.parameters?.short_description ?? ''),
      imageUrl: Array.isArray(widget.template.parameters)
        ? createImage()
        : createImage(widget.template.parameters?.image),
      altImage: widget.content_parameters.content?.name ?? '',
      primaryButtonText: Array.isArray(widget.template.parameters)
        ? ''
        : (widget.template?.parameters?.cta_title ?? ''),
    };
  },
};
